// Listings returned per preview list (added, removed); the counts always cover the whole scan.
export const VEHICLE_SELECTION_PREVIEW_LIMIT = 50;
